import { ILocaleLegacy } from '@locales/interfaces';

/**
 * @deprecated
 * @todo
 * These are legacy translations. Some of them are used silently (come from BE), while others are outdated.
 * Please remove keys if you are 100% sure that they are not used in the project anymore.
 */
export const ru = {
  IBCorporate: 'IB Корпоративный',
  IBIndividual: 'IB Индивидульный',
  MAMIndividual: 'MAM Individual',
  MAMMasterWithLPOA: 'MAM Individual',
  MarkupConfirmation: 'Markup Confirmation',
  UserCorporate: 'User Corporate',
  UserIndividual: 'User Individual',
  UserJoint: 'User Joint',
  account: {
    bankingDetails: 'Banking Details',
    createANewAccount: 'Создать новый аккаунт',
    register: 'Зарегистрироваться',
    registerSignInTitle: 'Уже зарегистрированы?',
  },
  admin: {
    user: {
      fields: {
        isMam: 'Is MAM',
        isSales: 'Is Sales User',
      },
    },
    tabs: {
      tradingSettings: {
        tradingAccountSettings: 'Trading Account Settings',
        setIBCode: 'Set IB Code',
      },
    },
    reports: {
      ftdUtmReport: {
        headerTitle: 'FTD_UTM Report',
        menuTitle: 'FTD_UTM Report',
      },
    },
  },
  adminSocialTrading: {
    title: 'Social Trading',
    investorAccountDetails: {
      tradingAccountName: 'Trading Account Name',
      balance: 'Balance',
      login: 'Login',
    },
    masterAccountDetails: {
      copyType: 'Copy Type',
      groupMappingType: 'Group Mapping Type',
      login: 'Login',
    },
  },
  backgroundJobs: {
    recurring: {
      title: 'Recurring Jobs',
    },
  },
  bonuses: {
    collectBirthdayGift: 'Collect your Birthday gift',
    availableTable: {
      bonusSize: 'Bonus Size',
    },
  },
  errors: {
    shared: {
      recordWasNotFound: 'Record was not found',
    },
    captcha: {
      captchaServerIsUnavailable:
        'Captcha server is unavailable. Please refresh the page and try again. If the problem remains please contact support via online chat or by email {{0}}',
    },
    files: {
      fileWasNotUploaded: 'File was not loaded',
    },
    mam: {
      linkIsInactive: 'Used link is not active',
    },
    trading: {
      profitSharingLimitWasExceeded:
        'Please note, that the max limit for profit sharing has been exceeded. The max limit is {{0}}%.',
      notEnoughMoney:
        'We apologize, but you do not have enough funds in your trading account to process the requested withdrawal. Please ensure that you have a sufficient balance available before attempting a withdrawal. Please note that in addition to the available balance, you should also consider the free margin level required for withdrawals.',
    },
    copyTrading: {
      equityIsLessOrEqualZero: 'The Master account is ineligible to be copied at this time, please try again later.',
    },
    securityCode: {
      emptyValue: 'The entered security value (password or PIN code) cannot be empty or null',
      invalidLength: 'The entered security value (password or PIN code) must contain {{0}} character(s)',
      invalidMinLength: 'The entered security value (password or PIN code) must contain at least {{0}} character(s)',
      invalidMaxLength: 'The entered security value (password or PIN code) must not exceed {{0}} character(s)',
      manyRepeatedValues:
        'The entered security value (password or PIN code) must not have more than {{0}} repeated character(s)',
      missingNumericValues: 'The entered security value (password or PIN code) must contain numeric character(s)',
      containsNumericValues: 'The entered security value (password or PIN code) must not contain any numeric values',
      missingLowerCaseValues: 'The entered security value (password or PIN code) must contain lowercase character(s)',
      containsLowerCaseValues:
        'The entered security value (password or PIN code) must not contain any lowercase values',
      missingUpperCaseValues: 'The entered security value (password or PIN code) must contain uppercase character(s)',
      containsUpperCaseValues:
        'The entered security value (password or PIN code) must not contain any uppercase values',
      missingSpecialValues: 'The entered security value (password or PIN code) must contain special character(s)',
      containsSpecialValues:
        'The entered security value (password or PIN code) must not contain any special characters',
      passwordChangeLimit: 'Password change attempts limit is exceeded. Please wait and try again',
    },
    user: {
      accountHasBeenDisabled: 'Sorry for the inconvenience, but the account {{0}} has been disabled',
      ageIsAboveMaxAllowed: 'We do not accept applications from anyone under {{0}} or over {{1}} years old.',
      ageIsUnderMinAllowed: 'We do not accept applications from anyone under {{0}} years old.',
      cantChangeLanguage: 'Cannot change language',
      fieldIsRequired: 'Field {{0}} is required',
      ibCodeIsIncorrect: "The IB code '{{0}}' is incorrect. Please enter a valid IB code",
      invalidCredentials: 'Invalid username {{0}} and/or password',
      invalidLengthOfPhoneNumber: 'The phone number length is invalid, please try again',
      invalidLink: 'The link is invalid',
      invalidPhoneNumberLength: 'The phone number length is invalid, please try again',
      onlyLatinCharactersAndDigitsAndSpecialSymbolsCanBeUsed:
        'Only latin characters, digits and special symbols can be used for {{0}} field',
      onlyLatinCharactersAndDigitsCanBeUsed: 'Only latin characters and digits can be used for {{0}} field',
      onlyLatinCharactersCanBeUsed: 'Only latin characters can be used for {{0}} field',
      onlyChineseCharactersCanBeUsed: 'Only chinese characters can be used for {{0}} field',
      personalDataNotEntered: 'Personal data are not entered',
      userCannotBeRestored:
        'Sorry, the record cannot be restored as the email or phone number of this profile is already in use with another profile, please delete the profile with the same email or phone number to restore this one',
      userDoesntExist: "User {{0}} doesn't exist",
      userEmailAlreadyExists: 'User email has been already registered in the system',
      userPhoneAlreadyExists: 'User phone has been already registered in the system',
      cantUpdateProfileActualStatus: "Can't update account {{0}}, actual status = {{1}}",
    },
  },
  formats: {
    formatFloat: '{{value, float}}',
    formatMoney: '{{value, money}}',
  },
  forms: {
    dragFile: 'or drag here your files',
    exportFormat: 'Формат экспорта',
    getCode: 'Отправить код',
    hide: 'Скрыть',
    limitMessage: '{{limit}} Characters left',
    resend: 'Отправить еще раз',
    seconds: 'sec',
    show: 'Показать',
  },
  headerWithBalance: {
    serverTime: 'Серверное время',
    failedToFetchServerTime: 'Не удалось получить серверное время',
    view: 'Просмотреть',
  },
  investors: {
    blackList: 'Black List',
  },
  legal: {
    clientAgreement: 'Client Agreement',
    privacyPolicy: 'Privacy Policy',
  },
  legalTradingPlatform: {
    data: 'Data',
  },
  masterProfile: {
    aboutMaster: 'About Master',
    infoFields: {
      ibCode: 'IB code',
    },
  },
  masters: {
    fields: {
      masterNickname: 'Master Nickname',
      rating: 'Position in Rating',
    },
  },
  menu: {
    deposit: 'Депозит',
  },
  messages: {
    CopyTrading: {
      InvestorAccountWasLinked: "Follower account started to copy Master account '{{MasterAccountName}}'.",
      InvestorAccountWasOpened:
        "Follower account was created. Follower account started to copy Master account '{{InvestorAccountName}}'.",
      InvestorAccountWasUnlinked: "Follower account stopped to copy Master account '{{MasterAccountName}}'.",
      MasterAccountWasChanged:
        'Master account was modified. (Profit sharing={{ProfitSharing}}, Allocation method={{AllocationMethod}})',
      MasterAccountWasLinked: "Follower's account '{{InvestorAccountName}}' started to copy Master account.",
      MasterAccountWasOpened:
        'Master account was created. (Profit sharing={{ProfitSharing}}, Allocation method={{AllocationMethod}})',
      MasterAccountWasUnlinked: "Follower's account '{{InvestorAccountName}}' stopped to copy Master account.",
    },
  },
  modal: {
    error: 'Ошибка',
    notification: 'Уведомление',
    ok: 'Ok',
  },
  operationHistory: {
    filterName: 'Search',
    placeholder: 'Please enter',
  },
  pageTitles: {
    admin: {
      financialIdentity: {
        children: {
          cards: 'Cards',
        },
      },
    },
  },
  partnership: {
    salesTitle: 'Sales',
    ibInfo: {
      detailsTitle: 'IB Details',
      nextRebatePayment: 'Next Rebate Payment',
      statistics: {
        closetTradersReport: {
          type: 'Type',
        },
        tradingVolReport: {
          subIb: 'Sub-IB',
        },
      },
    },
    ibSettings: {
      referralLinkError: 'Markups are incorrect! Please contact our support team to get correct markups',
    },
    salesUserInfo: {
      aeCode: 'AE Code',
    },
  },
  profile: {
    adult: 'Мне есть 18 лет',
    code: 'Код',
    country: 'Страна',
    documentsUploaded: 'Загруженные документы',
    isAgreeWithTermsAndConditions: 'I accept the <0>Client Agreement</0> and the <1>Privacy Policy</1>',
    pleaseValidateAccountToDeposit:
      'Your personal details require verification by {{brokerName}} compliance team. Before proceeding to deposits you need to submit a scan of your ID',
    successChangeDescription: 'Changes are saved!',
    warningMessage: {
      profileIsBeingVerified: 'Your profile is being verified, it might take a couple of seconds',
    },
  },
  psp: {
    accountsFetchFailErr: 'Не удалось получить аккаунты',
    confirmEveryTransaction: 'Confirm every transaction, deposits take up to 24 hours',
    deposit: {
      depositForm: {
        accountNameTitle: 'Account Name',
        addressLine2: 'Address Line 2',
        beneficiaryAccountNumberTitle: 'Beneficiary Account Number',
        beneficiaryBankHint: 'Пожалуйста, выберите банковский аккаунт',
        beneficiaryBankNameHint: 'Bank Name, e.g. (Standard Charted Bank)',
        cardNameTitle: 'Card Name',
        localDepositFileHint: 'Please attach a document confirming payment if need',
      },
      depositTitle: 'Депонировать средства',
      notice: 'Withdrawals are available only for verified accounts',
      warnToSubmitPersonalDetails:
        'Чтобы сделать депозит, пожалкйста заполните свои персональные данные. Пожалуйста, убедитесь, что данные совпадают с Вашими документами',
    },
    localAgentTable: {
      login: 'Login',
    },
    operationsFetchFailErr: 'Не удалось получить операции',
    operationsTable: {
      documentTitle: 'Document',
      operationsTableTitle: 'Недавние операции',
      paymentSystemTitle: 'Платежная система',
    },
    pluginInfoFetchFailErr: 'Не удалось получить информацию о плагине',
    pluginNotFound: 'Plugin not found',
    pluginsFetchFailErr: 'Не удалось получить плагины',
    preAuthorizedBanking: 'Pre-Authorized Banking',
    qrCodeCryptoNotice:
      'The QR Code is for one-time only. Do not scan this code in crypto application more than once, otherwise your payment will be suspended.',
    qrCodeCryptoTitle: 'QR Code for crypto application',
    resentOperationsTitle: 'Недавние операции',
    transfer: {
      transactionDetailsTitle: 'Подробности транзакции',
      transferForm: {
        amountError: 'Превышена допустимая сумма перевода',
        currencyTitle: 'Валюта',
      },
    },
    uploadBankStatementWithBankName:
      'Upload a bank statement which contains Bank Name, your Full Name and Bank Account Number',
    uploadPayslip: 'Upload the bank payslip of your deposit',
    uploadYourDocument: 'Please confirm your deposit by uploading your bank statement',
    withdrawal: {
      notice: 'Withdrawals are available only for verified accounts',
      withdrawalTitle: 'Снять средства',
      withdrawalForm: {
        bankNameTitle: 'Bank Name',
        beneficiaryCryptoWalletHint: 'A wallet number with cryptocurrency money will be sent to',
        beneficiaryCryptoWalletTitle: 'Beneficiary Crypto Wallet',
        confirmTitle: 'Confirm withdraw information',
      },
    },
  },
  settings: {
    docsForm: {
      documentNumberHint: 'Check if Identification number is the same as on the photo',
      documentTypeHint:
        'Пожалуйста, убедитесь, что Вы представляете фотографию хорошего качества или скан действующего документа',
      uploadedDocumentsTable: {
        docNameTitle: 'Имя Документа',
        documentNumber: 'Номер Документа',
        typeTitle: 'Тип Документа',
      },
    },
    profileForm: {
      editProfileTitle: 'Редактировать профиль',
      proceedToDeposit: 'Перейти к депозиту',
      saveUserSuccessMessage: 'Профиль был успешно сохранен',
      userDetailsErrorMessage: 'Не удалось получить профиль пользователя',
      verifyPersonalDetails: 'Проверка персональных данных',
      verifyProfileBtn: 'Верифицировать Профиль',
    },
  },
  socialTradingModal: {
    copyHint: 'Your Account {{account}} will stop to copy Master {{oldMaster}}, and start to copy {{newMaster}}',
  },
  tradingAccounts: {
    accountDetailsTitle: 'Торговый аккаунт',
    accountHistoryForm: {
      closeTimeTitle: 'Время закрытия',
    },
    changeTradingAccountName: 'Change trading account name',
    connectedAccounts: 'Connected Accounts',
    currency: 'Валюта',
    depositForm: {
      amountTitle: 'Сумма',
      errorMessage: 'Не удалось депонировать средства',
      successMessage: 'Депозит был сделан успешно',
    },
    descriptionPlaceholder: 'Enter recommendation for you followers',
    fetchServersErr: 'Не удалось получить сервера',
    ibCode: 'IB (опционально)',
    notRows: 'Нет строк для отображения',
    openAccountModalSubTitle: 'The widest range of trading instruments: currencies, metals. Standard trading terms.',
    tradingPlatforms: 'Торговые платформы',
    transferForm: {
      title: 'Transfer Funds',
    },
    withdrawForm: {
      amountTitle: 'Сумма',
      errorMessage: 'Не удалось сохранить левередж',
      successMessage: 'Снятие средств было успешно выполнено',
    },
  },
} satisfies ILocaleLegacy;
